export const colors = {
  // Primary Colors
  CBA_DarkBlue: '#004582',
  CBA_Blue: '#009ada',
  CBA_Blue_Dark: '#004582',
  CBA_lightBlue: '#53AAE0',
  CBA_Green: '#5CB85C',
  CBA_Orange: '#F0AD4E',
  CBA_DarkOrange: '#D38037',

  // Grey Scale
  CBA_Grey1: '#29343e',
  CBA_Grey2: '#5c6f82',
  CBA_Grey3: '#899dac',
  CBA_Grey4: '#dbe5e9',
  CBA_Grey5: '#edf0f5',
  CBA_Grey6: '#f7fbfd',

  // Secondary Colors
  CBA_Error: '#E2464C',
  CBA_Info: '#1c7cd5',
  CBA_Correct: '#32A430',
  CBA_Alert: '#ee9800',

  // Common Colors
  white: '#FFFFFF',
  black: '#000000',
  lightGrey: '#f8f9fa',
  mediumGrey: '#e0e0e0',
  darkGrey: '#6c757d',
  blue: '#007bff',
  CBA_Blue_Darker: '#003d7a',
  CBA_Grey7: '#f0f2f5',
  CBA_Grey8: '#f1f1f1',
  CBA_Grey9: '#ccc',
  CBA_Grey10: '#aaa',
  CBA_Grey11: '#f5f7fa',
};
